import { Avatar, Button, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';

import styles from './addedCaller.module.scss';

const callStateMessage = {
  ringing: 'Ringing...',
  failed: 'Call failed',
  busy: 'Call busy',
  noAnswer: 'No answer',
  inProgress: '',
};

type AddedCallerProps = {
  /** Extra classnames */
  className?: string;
  /** Is the call on hold? */
  isOnHold: boolean;
  /** On hold toggle callback */
  onHoldToggle?: () => void;
  /** End call callback */
  onEndCall?: () => void;
  /** Caller info */
  caller: User;
  /**
   * The current state of the call
   *
   * @param {string} callState - Can be one of 'ringing', 'failed', 'busy',
   *   'noAnswer', 'inProgress'
   */
  callState: keyof typeof callStateMessage;
};

export class AddedCaller extends PureComponent<AddedCallerProps> {
  render() {
    const {
      className,
      isOnHold,
      onHoldToggle,
      onEndCall,
      caller,
      callState,
      ...otherProps
    } = this.props;

    const rootClass = classnames(
      {
        [styles.addedCaller]: true,
      },
      className,
    );

    const canRemove =
      onEndCall && ['ringing', 'inProgress'].includes(callState);
    const canHold = onHoldToggle && callState === 'inProgress';

    return (
      <div {...otherProps} className={rootClass}>
        <Icon className={styles.icon} name="plus" size={24} />
        <div className={styles.avatarWrap}>
          <Avatar user={caller} />
        </div>
        <span className={styles.name}>
          {caller.name || caller.phone_number}
        </span>
        <span className={styles.callState}>{callStateMessage[callState]}</span>
        <div className={styles.buttons}>
          {canRemove && (
            <Button
              className={styles.button}
              onClick={onEndCall}
              variant="danger"
            >
              End call
            </Button>
          )}
          {canHold && (
            <Button
              variant={isOnHold ? 'primary' : 'secondary'}
              className={styles.button}
              onClick={onHoldToggle}
            >
              {isOnHold ? 'Unhold' : 'Hold'}
            </Button>
          )}
        </div>
      </div>
    );
  }
}
